import { useEffect } from "react";

import { useRouter } from "@tanstack/react-router";

export const useRefetchOnTabFocus = () => {
  const router = useRouter();

  useEffect(() => {
    let lastRefreshAt = -Infinity;
    const refresh = () => {
      if (document.visibilityState !== "visible") return;
      const now = Date.now();
      if (now - lastRefreshAt < 1000) return;
      lastRefreshAt = now;
      router.invalidate();
    };

    document.addEventListener("visibilitychange", refresh);
    window.addEventListener("focus", refresh);

    return () => {
      document.removeEventListener("visibilitychange", refresh);
      window.removeEventListener("focus", refresh);
    };
  }, [router]);
};
